import { Button, type ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  justifyContent: 'flex-start',
  position: 'unset',
  boxShadow: 'none',
  backgroundColor: 'transparent',
  height: '40px',
  '&.Mui-focusVisible': {
    outline: 'none',
    outlineOffset: '0px',
  },
  '@media (forced-colors: active)': {
    border: 'none !important',
    borderRadius: '0 !important',
  },
  '&::after': {
    content: '""',
    flexGrow: 1,
    position: 'absolute',
    width: '100%',
    height: '40px',
    left: 0,
    zIndex: 1,
    backgroundColor: theme.vars?.palette.secondary.main,
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    borderRadius: '100px',
    transition: theme.transitions.create(['background-color'], {
      duration: theme.transitions.duration.short,
    }),
    '@media (forced-colors: active)': {
      backgroundColor: 'ButtonText !important',
      color: 'ButtonFace !important',
    },
  },
  '&.Mui-disabled': {
    backgroundColor: 'transparent !important',
    '&::after': {
      backgroundColor: theme.vars?.palette.action.disabledBackground,
      color: theme.vars?.palette.action.disabled,

      '@media (forced-colors: active)': {
        backgroundColor: 'GrayText !important',
      },
    },
  },
  '&.MuiButton-loading': {
    '& .MuiTypography-root': {
      '@media (forced-colors: active)': {
        color: 'transparent !important',
      },
    },
    '& .MuiButton-loadingIndicator': {
      zIndex: 2,
      '@media (forced-colors: active)': {
        color: 'ButtonFace !important',
      },
    },
  },

  '&:hover::after': {
    backgroundColor: theme.vars?.palette.secondary.dark,
    color: theme.palette.getContrastText(theme.palette.secondary.dark),
    '@media (forced-colors: active)': {
      backgroundColor: 'Highlight !important',
      color: 'HighlightText !important',
    },
  },
  '&:focus-visible::after': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '2px',
  },
}));
